<template>
  <v-tooltip top>
    <template #activator="{ on, attrs }">
      <v-btn
        fab
        small
        v-bind="{...defaults, ...$attrs, ...attrs}"
        v-on="{...$listeners, ...on}"
      >
        <v-icon>
          mdi-plus
        </v-icon>
      </v-btn>
    </template>
    <span>{{ hoverValue }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'AddNewButton',
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    hoverValue: {
      type: String,
      default: undefined
    }
  },
  beforeCreate() {
    this.defaults = {
      color: 'primary'
    }
  }
}
</script>
